import { BellOff, BellRing, Check } from "lucide-react";
import { useTranslate } from "ra-core";
import { useState } from "react";

import { Button } from "@/components/ui/button";

import {
  getNotificationSupport,
  requestNotificationPermission,
  type NotificationSupport,
} from "./notifications";

export const NotificationPermissionButton = () => {
  const translate = useTranslate();
  const [support, setSupport] = useState<NotificationSupport>(
    getNotificationSupport,
  );

  if (support === "unsupported") {
    return (
      <p className="text-xs text-muted-foreground">
        {translate("crm.personal.reminders.unsupported")}
      </p>
    );
  }

  if (support === "granted") {
    return (
      <span
        className="flex items-center gap-1 text-xs text-muted-foreground"
        title={translate("crm.personal.reminders.hint")}
      >
        <Check className="size-3" />
        {translate("crm.personal.reminders.enabled")}
      </span>
    );
  }

  if (support === "denied") {
    return (
      <span className="flex max-w-sm items-start gap-1 text-xs text-muted-foreground">
        <BellOff className="mt-0.5 size-3 shrink-0" />
        {translate("crm.personal.reminders.denied")}
      </span>
    );
  }

  return (
    <Button
      variant="outline"
      size="sm"
      title={translate("crm.personal.reminders.hint")}
      onClick={async () => setSupport(await requestNotificationPermission())}
    >
      <BellRing />
      {translate("crm.personal.reminders.enable")}
    </Button>
  );
};
